import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  template: ``,
})
export class _buttonBaseComponent implements OnInit {
  @Input() isDisabled: boolean = false;
  @Input() protected buttonText: string = '';
  @Output() btnClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

}
